module.exports = __webpack_public_path__ + "img/back-top.b2de527e.png";